import React, { useState } from "react";
import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { itemClass } from "./navConfig";
import { ChevronDown, ChevronRight } from "lucide-react";

const NavItem = ({ item, collapsed, onNavigate }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  if (item.children) {
    const childActive = item.children.some((c) => location.pathname === c.to);
    if (collapsed) {
      return (
        <button title={item.label} onClick={() => { navigate(item.children[0].to); onNavigate?.(); }}
          className={`${itemClass(childActive)} justify-center px-0`} data-testid={item.testid}>
          <item.icon className="h-[18px] w-[18px] shrink-0" />
        </button>
      );
    }
    return (
      <div>
        <button onClick={() => setOpen((v) => !v)} className={itemClass(childActive && !open)}
          data-testid={item.testid}>
          <item.icon className="h-[18px] w-[18px] shrink-0" />
          <span className="flex-1 text-start">{item.label}</span>
          {open ? <ChevronDown className="h-4 w-4 opacity-60" /> : <ChevronRight className="h-4 w-4 opacity-60" />}
        </button>
        {open && (
          <div className="mt-1 ms-4 ps-3 border-s border-border flex flex-col gap-0.5"
            data-testid={`${item.testid}-menu`}>
            {item.children.map((c) => (
              <NavLink key={c.to} to={c.to} onClick={onNavigate} data-testid={c.testid}
                className={({ isActive }) =>
                  `px-3 py-2 rounded-lg text-sm transition-colors ${
                    isActive ? "text-foreground font-semibold bg-accent" : "text-muted-foreground hover:text-foreground hover:bg-card/60"
                  }`}>
                {c.label}
              </NavLink>
            ))}
          </div>
        )}
      </div>
    );
  }

  return (
    <NavLink to={item.to} end={item.end} onClick={onNavigate} data-testid={item.testid}
      title={collapsed ? item.label : undefined}
      className={({ isActive }) => `${itemClass(isActive)} ${collapsed ? "justify-center px-0" : ""}`}>
      <item.icon className="h-[18px] w-[18px] shrink-0" />
      {!collapsed && <span>{item.label}</span>}
    </NavLink>
  );
};

export const NavList = ({ sections, collapsed = false, onNavigate }) => (
  <nav className="flex flex-col gap-6">
    {sections.map((s) => (
      <div key={s.label}>
        {!collapsed && (
          <div className="px-3 pb-2 text-[10px] font-bold uppercase tracking-[0.2em] text-muted-foreground/70">
            {s.label}
          </div>
        )}
        <div className="flex flex-col gap-0.5">
          {s.items.map((it) => (
            <NavItem key={it.to || it.label} item={it} collapsed={collapsed} onNavigate={onNavigate} />
          ))}
        </div>
      </div>
    ))}
  </nav>
);
